/**
 * QuantityInput is a text input that allows you to adjust the quantity of an item.
 *  @param {object} item - The item that's being modified.
 *  @param {string} item.id - Unique identifier for the item
 *  @param {string} item.name - Name for the item
 *  @param {integer} item.quantity - The quantity of the item. This is the value you are modifying with this component.
 *  @param {string} item.validationClasses - Optional. Any classes you want to pass in to the Input field to indicate whether the input is valid.
 *  @param {function} item.handleInputQuantity - A callback function that handles updating the value of the item via the typed in input. Can handle decimals and precision.
 */
/**
 * This callback is used to update the input quantity via the text input.
 * @callback handleInputQuantity
 * @param {string} quantity = The stringified new quantity for the item, eg "4.55".
 */
import PropTypes from "prop-types"
import React from "react"

class QuantityInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <input
        className={`w-20 rounded border ${this.props.validationClasses || ""}`}
        type="number"
        inputMode="decimal"
        min="0.0001"
        onChange={(event) => this.props.handleInputQuantity(event.target.value)}
        id={this.props.item.id}
        name={this.props.item.name}
        value={this.props.item.quantity}
        placeholder="0.0000"
        aria-label="quantity"
      />
    )
  }
}

QuantityInput.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
  }).isRequired,
  handleInputQuantity: PropTypes.func.isRequired,
  validationClasses: PropTypes.string,
}

export default QuantityInput
